export default "__VITE_ASSET__1MxkBl99__"